export default "__VITE_ASSET__PUt0iNwR__"